/**
 * Admin "Agent Configuration" types.
 *
 * Mirrors the agent runtime config stored in DynamoDB and served by the
 * admin-gated endpoints: the active Bedrock model and the per-sport season
 * context the agent injects into its prompts.
 */

/** The season-value formats an admin may assign to a sport. */
export const SEASON_FORMATS = ["YYYY-YY", "YYYY", "custom"] as const;
export type SeasonFormat = (typeof SEASON_FORMATS)[number];

/** The active model the agent runs. */
export interface AgentModel {
  modelId: string;
  modelName: string;
  lastChangedBy: string | null;
  lastChangedAt: string | null;
}

/** A configured sport's current-season context. */
export interface SportSeason {
  sport: string;
  currentSeason: string;
  format: string;
  lastChangedBy: string | null;
  lastChangedAt: string | null;
}

/** A selectable Bedrock foundation model (Claude / Nova). */
export interface FoundationModel {
  modelId: string;
  modelName: string;
  provider: string;
}

/**
 * The chat kill-switch (andon cord) status. ``enabled: false`` means chat is
 * halted: the WebSocket handler stops enqueuing new turns and answers a
 * maintenance message instead. Default-on — an unset switch reports enabled.
 */
export interface ChatStatus {
  enabled: boolean;
  reason: string | null;
  lastChangedBy: string | null;
  lastChangedAt: string | null;
}

export interface GetAgentConfigResponse {
  model: AgentModel;
  sports: SportSeason[];
  chatStatus: ChatStatus;
}

export interface GetFoundationModelsResponse {
  models: FoundationModel[];
}
